import axios from 'axios';
import { getApiBase } from '../apiBase';

const API = axios.create({ baseURL: getApiBase(), withCredentials: true, timeout: 120000 });

/**
 * Static Oracle Fusion SQL review — tables, flags, markdown skeleton.
 * @param {string} sql
 * @param {{ advisorText?: string, source?: string }} [opts]
 */
export async function reviewOracleSql(sql, opts = {}) {
  const res = await API.post(
    '/api/copilot/review-sql',
    {
      sql,
      advisorText: opts.advisorText,
      source: opts.source,
    },
    { validateStatus: () => true }
  );
  if (res.status !== 200) {
    const err = new Error(res.data?.error || `Review failed (HTTP ${res.status})`);
    err.status = res.status;
    err.response = res;
    throw err;
  }
  return res.data;
}
